module.exports = __webpack_public_path__ + "static/undraw_all_the_data_h4ki-3486f2178beb44f70ba7e18d11afe5e8.svg";